export const CONNECTION_EVENTS = {
  LOGIN: 'login',
  DATA: 'data',
  STATUS: 'status',
  ERROR: 'error',
  SSH_ERROR: 'ssherror',
};

export const EXIT_COMMAND = 'exit';
